// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CircleProgress_wrapper","label":"CircleProgress_label"};